<footer class="footer">
  <section class="flex flex-jc-c flex-ai-c power-by">
    Powered by
    <a href="http://6cube.eu/" target="_blank">
      <img src="assets/images/6cube.png" height="32" alt="www.6cube.eu" />
    </a>
  </section>
</footer>
